__webpack_require__.p = "https://static.age.awaze.com/search-mfe/c81e106/_next/";